import { useState } from "react";
import Button from "@/common/ui/Button";
import { LightText2 } from "@/common/ui/Text";
import { toastMessage } from "@/utils/helper/myToast";
import { deleteAttachment } from "@/services/employee.services";
import { useParams } from "react-router-dom";

const DeleteAttachment = ({ data, onClose }: any) => {
  const [isLoading, setIsLoading] = useState(false);
  const { employeeId } = useParams();

  const handleDelete = async () => {
    setIsLoading(true);
    try {
      const res: any = await deleteAttachment({ empId: employeeId, acTyp: "delete", attachmentId: data?.id });
      if (res?.status === 200) {
        const { message, isError } = res.data;
        onClose();
        return toastMessage(message, isError);
      } else {
        console.log("Error", res);
        const { message, isError } = res?.response?.data || {};
        if (message) {
          return toastMessage(message, isError);
        }
        if (res.message) {
          return toastMessage(res.message, true);
        }
      }
    } catch (error) {
      console.error("Error deleting employee", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-3 md:p-4 relative">
      <div className="px-1 pb-4">
        <LightText2 text={`Are you sure you want to delete ${data?.name}?`} />
      </div>
      <div className="flex justify-end">
        <div className="flex justify-between gap-4">
          <Button variant="outline" size="small" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="outline-danger" size="small" onClick={handleDelete} isLoading={isLoading}>
            Delete
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DeleteAttachment;
